import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  skipReprocessing: {
    defaultMessage: 'Keep this ship date when reprocessing automations',
    description: 'Checkbox label to keep the set ship date when reprocessing workflow automations',
    id: 'm7/cw8',
  },
});
